export default {
  has_extended_session: false,
  extended_session_uid: null,
  extended_session_role: null,
  extended_access_token: null,
  extended_session_user: null,
}